import {
  useSelector as useReduxSelector,
  TypedUseSelectorHook,
} from 'react-redux'

import { State } from '../store/state'

export const useSelector: TypedUseSelectorHook<State> = useReduxSelector
